<!-- ==================================== POPUP : Consultation Letter (STARTS) ============================================== -->

<div>

    <form [formGroup]="consultation">

        <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
            <div class="w100">

                <div class="l-flex l-flex-c t-field t-field-pad">

                    <label>
                        Type of Letter
                    </label>

                    <i class="t-sep"></i>

                    <span class="t-validation-wrap l-fg1">
                       
                        <select class="t-select w100" #Title formControlName="Title" [ngClass]="! consultation.get('Title').value? 'is-invalid':''">
                            <option [ngValue]="" disabled>Please select a title</option>
                            <option value="Consultation Letter">Consultation Letter</option>
                            <option value="Gynecology Consult Letter">Gynecology Consult Letter</option>
                            <option value="Obstetrics Consult Letter">Obstetrics Consult Letter</option>
                            <option value="Visit Confirmation">Visit Confirmation</option>
                            <option value="Visit Summary">Visit Summary</option>
                            <option value="Summary And Visit Recommendation">Summary And Visit Recommendation</option>
                        </select>
                        <div class="t-validation-message">
                            <span>Please select a title</span>
                        </div>
                    </span>

                </div>

            </div>
            <div class="w100 h100 summary-anamnesis">


                <section class="m-box fulltext" style="padding-bottom: 0;">
                    <h2>{{es.ExamType}}</h2>
                    <angular-editor class="scroller scroller-intro fulltext" formControlName="FormContent" style="width: 100%;" [config]="editorConfig">
                    </angular-editor>
                    <button class="t-btn-edit"
                        (click)="atS.showAuto(consultation.get('FormContent'),'Consultation Letter',91)">Auto
                        Text</button>
                </section>


            </div>
        </div>
    </form>
</div>


<div class="second-layer-popup">
    <div class="second-layer-popup-frame">
        <div class="second-layer-popup-body"></div>
    </div>
</div>
<app-autotext *ngIf="atS.Display"></app-autotext>


<!-- ===================================== POPUP : Consultation Letter (END)  =============================================== -->